<div class="columns">
  <div class="column is-narrow is-offset-6 is-flex-desktop-only">
    <div class="pageTitle has-background-transparent-white"><ng-content></ng-content></div>
  </div>
</div>
